<template>
  <router-view />
</template>

<style>
/* 确保全屏承载组件 */
#app { width: 100%; height: 100vh; }
</style>